export const getVyEnvUnsafe = () => window.__vyEnv || "unknown";

export const getDatadogConfig = () => {
  const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
  const service = import.meta.env.VITE_DATADOG_SERVICE;

  if (!applicationId || !clientToken || !service) {
    return null;
  }

  return {
    applicationId,
    clientToken,
    service,
  };
};

export const getAnonymousUserId = () => {
  const ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY = "anonymousUserId";
  const storedAnonymousUserId = window.localStorage.getItem(
    ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY,
  );

  if (storedAnonymousUserId) {
    return storedAnonymousUserId;
  }

  const newAnonymousUserId = window.crypto.randomUUID();
  window.localStorage.setItem(
    ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY,
    newAnonymousUserId,
  );
  return newAnonymousUserId;
};
